let stickyActButton = document.querySelector(".sticky-atc, .subscription-sticky-atc");
let stickyActMediaQuery = window.matchMedia("(min-width: 650px)");

function initializeStickyAddToCart() {
  if (stickyActButton) {
    let priceWrapper = document.getElementById("stickyBottomTotalPrice");
    let addToCartButton = document.querySelector("#stickyBottomTotalPrice + button");

    let mainCartButton = document.querySelector("#add-to-cart-main-button");
    let body = document.querySelector("body");
    let customizeBlock = null;
    if(document.querySelector("bundled-product"))
      customizeBlock = document.querySelectorAll(".sticky-atc-bundle")[0];
    else
      customizeBlock = document.querySelectorAll(".pdp_pww_block")[0];
    let nocustomizeBlock = document.getElementById("variantCustomization");


    if (customizeBlock) {
      let customizeBlockFirstItem = null;
      let eachBlockHeight = null;
      if(document.querySelector("bundled-product")){
        customizeBlockFirstItem = customizeBlock.querySelector(".price-selected-snippet");
        eachBlockHeight = customizeBlock.getElementsByTagName("div")[0].clientHeight;
      }
      else{
        customizeBlockFirstItem = customizeBlock.querySelectorAll(".pdp_pww-section")[0];
        eachBlockHeight = customizeBlock.querySelector(".pdp_fwp_block_product").getElementsByTagName("div")[0].clientHeight;
      }

      window.addEventListener("scroll", stickyActButtonVisibility);
      window.addEventListener("load", stickyActButtonVisibility);

      function stickyActButtonVisibility() {
        let customizeBlockView = customizeBlock.getBoundingClientRect().bottom;
        let customizeBlockFirstItemView = null;
        if(document.querySelector("bundled-product"))
          customizeBlockFirstItemView = customizeBlock.querySelector('.price-selected-snippet').getBoundingClientRect().bottom;
        else
          customizeBlockFirstItemView = customizeBlockFirstItem.getBoundingClientRect().bottom;
        let stickyActBlockMediaQuery = window.matchMedia("(min-width: 650px)");
        if (stickyActBlockMediaQuery.matches) {
          if (customizeBlockView - eachBlockHeight <= window.innerHeight) {
            body.classList.remove("sticky-atc-not-active");
            body.classList.add("sticky-atc-active");
            stickyActButton.classList.remove("hide");
            stickyActButton.classList.add("show");
          } else {
            body.classList.add("sticky-atc-not-active");
            body.classList.remove("sticky-atc-active");
            stickyActButton.classList.add("hide");
            stickyActButton.classList.remove("show");
          }
        } else {
          if(document.querySelector("bundled-product")){
            let customizeBelowBundle = document.querySelector(".js_all_products");
            let customizeBlockViewBelow = customizeBelowBundle.getBoundingClientRect().bottom;
            if(customizeBlockViewBelow <= 0)
              document.querySelector("#selectedBundleItems").classList.remove("d-none");
            else
              document.querySelector("#selectedBundleItems").classList.add("d-none");
          }

          if (customizeBlockFirstItemView <= window.innerHeight) {
            body.classList.remove("sticky-atc-not-active");
            body.classList.add("sticky-atc-active");
            stickyActButton.classList.remove("hide");
            stickyActButton.classList.add("show");
          } else {
            body.classList.add("sticky-atc-not-active");
            body.classList.remove("sticky-atc-active");
            stickyActButton.classList.add("hide");
            stickyActButton.classList.remove("show");
          }
        }
      }
    }
    else if (nocustomizeBlock) {
      window.addEventListener("scroll", stickyActButtonVisibility);
      window.addEventListener("load", stickyActButtonVisibility);

      function stickyActButtonVisibility() {
        let nocustomizeBlockView = nocustomizeBlock.getBoundingClientRect().bottom;
        let nocustomizeBlockViewMobile = nocustomizeBlock.getBoundingClientRect().bottom -nocustomizeBlock.getBoundingClientRect().height / 2;

        let stickyActBlockMediaQuery = window.matchMedia("(min-width: 650px)");

        if (stickyActBlockMediaQuery.matches) {
          if (nocustomizeBlockView <= window.innerHeight) {
            body.classList.remove("sticky-atc-not-active");
            body.classList.add("sticky-atc-active");
            stickyActButton.classList.remove("hide");
            stickyActButton.classList.add("show");
          } else {
            body.classList.add("sticky-atc-not-active");
            body.classList.remove("sticky-atc-active");
            stickyActButton.classList.add("hide");
            stickyActButton.classList.remove("show");
          }
        } else {
          if (nocustomizeBlockViewMobile <= window.innerHeight) {
            body.classList.remove("sticky-atc-not-active");
            body.classList.add("sticky-atc-active");
            stickyActButton.classList.remove("hide");
            stickyActButton.classList.add("show");
            stickyImageVisibility();
          } else {
            body.classList.add("sticky-atc-not-active");
            body.classList.remove("sticky-atc-active");
            stickyActButton.classList.add("hide");
            stickyActButton.classList.remove("show");
            stickyImageVisibility();
          }
        }

        function stickyImageVisibility() {
          let newPDPBundleBlock = document.querySelector(".pdp-your-bundle-section");
          let customizeBlockView = newPDPBundleBlock.getBoundingClientRect();
          let stickyActBlockMediaQuery = window.matchMedia("(min-width: 650px)");

          if (!stickyActBlockMediaQuery.matches) {
            if (customizeBlockView.bottom <= 0) {
              stickyActButton.querySelector(".atc-bundle_price").classList.add("image-show");
            } else {
              stickyActButton.querySelector(".atc-bundle_price").classList.remove("image-show");
            }
          }
        }

      }
    } else {
      return;
    }

    let stickyAtcEditLookInsideBox = document.querySelector("#stickyAtcEditLookInsideBox");
    let lookInisideBoxPillButton = document.querySelector(".lookInsideBoxPill__js");
    let lookInisideBoxSection = document.getElementById("lookInsideBox__js");
    let stickyAtcEdit = document.querySelector("#stickyAtcEdit");
    let selectedBundleItems = document.querySelector("#selectedBundleItems");
    let header = document.getElementById("shopify-section-header");

    if (stickyAtcEditLookInsideBox && lookInisideBoxPillButton && lookInisideBoxSection) {
      stickyAtcEditLookInsideBox.addEventListener("click", debounce(function () {
        lookInisideBox.scrollIntoView(false);
      }), 100);
    }

    if (stickyAtcEdit) {
      stickyAtcEdit.addEventListener( "click", debounce(function () {
        let el = document.getElementById("variantCustomization");
        el.scrollIntoView();
        header.classList.add("shopify-section-header-hidden");
      }), 100);
    }

    if (selectedBundleItems) {
      selectedBundleItems.addEventListener("click", debounce(function () {
        let el = document.querySelector("bundled-product");
        el.scrollIntoView();
        header.classList.add("shopify-section-header-hidden");
      }), 100);
    }
  }
}

// Call the function to execute the script
initializeStickyAddToCart();

function checkVisible(elm) {
  let rect = elm.getBoundingClientRect();
  let viewHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight
  );
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}
